import Vue from "vue";

Vue.directive("close-offcanvas",
    {
        bind(el, binding)
        {
            el.onclick = function(event)
            {
                if (document.querySelector(".mobile-filter"))
                {
                    document.querySelector(".mobile-filter").classList.remove("open");
                    document.querySelector(".mobile-navigation").classList.remove("open");
                    document.querySelector("body").classList.remove("menu-is-visible");
                    document.querySelector("body").classList.remove("basket-open");
                }
            };
        }
    });
